import styled from 'styled-components';

/* Utils */
import { mediaQuery, assignIfDefined } from 'styles/Utils';

export const WishLocalLogoWrapper = styled.div<{ width?: string }>`
  ${assignIfDefined('width')};
  svg {
    ${mediaQuery.mobile`
      width: 121px;
      ${assignIfDefined('width')};
    `}
    ${mediaQuery.desktop`
      width: 168px;
      ${assignIfDefined('width')};
    `}
  }
`;
